import React from 'react';
import Section from './Section';
// import { blogPosts } from '../data/posts';

const BlogList = () => {
  return (
    <Section id="blog" className="bg-white">
      <div className="text-center mb-16">
        <h2 className="text-4xl lg:text-5xl font-bold text-text mb-6">
          Blog para Padres
        </h2>
        <p className="text-xl text-text/70 max-w-3xl mx-auto">
          Artículos y consejos útiles para apoyar el desarrollo de tu hijo
        </p>
      </div>

      {/* <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {blogPosts.map((post) => (
          <article key={post.id} className="card group hover:shadow-2xl transition-all duration-500 overflow-hidden">
            {/* Imagen 
            <div className="relative overflow-hidden">
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-4 left-4 bg-primary text-white px-3 py-1 rounded-full text-sm font-medium">
                {post.category}
              </div>
              <div className="absolute top-4 right-4 bg-white/90 text-text px-2 py-1 rounded text-sm">
                {post.readTime}
              </div>
            </div>

            {/* Contenido 
            <div className="p-6 space-y-4">
              <div className="flex items-center space-x-2 text-sm text-text/60">
                <span>📅</span>
                <span>{new Date(post.date).toLocaleDateString('es-ES', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}</span>
              </div>

              <h3 className="text-xl font-bold text-text group-hover:text-primary transition-colors">
                {post.title}
              </h3>

              <p className="text-text/70 leading-relaxed">
                {post.excerpt}
              </p>

              <button className="text-primary hover:text-primary/80 font-medium text-sm transition-colors group-hover:translate-x-1 transform duration-300">
                Leer más →
              </button>
            </div>
          </article>
        ))}
      </div> */}

      {/* CTA para suscripción */}
      <div className="mt-16 text-center">
        <div className="bg-gradient-to-r from-primary/10 to-secondary/20 rounded-2xl p-8 max-w-2xl mx-auto">
          <h3 className="text-2xl font-bold text-text mb-4">
            ¿Buscas más recursos para padres?
          </h3>
          <p className="text-text/70 mb-8">
            Descubre nuestro Blog de Padres con artículos, consejos y herramientas para acompañar el desarrollo de tu hijo.
          </p>
          <a
            href="https://encuadrado.com/p/centro-volantin"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-lg px-8 py-4 font-bold shadow-lg hover:scale-105 transition-transform duration-300"
          >
            Ir al Blog de Padres
          </a>
        </div>
      </div>
    </Section>
  );
};

export default BlogList;
